// @flow

import React, { Component } from "react";
import { localize } from "redux-i18n";
import { Field, reduxForm } from "redux-form";
import type { FormProps } from "redux-form";
import { Dropdown, DatePickerFormWrapper } from "@components/form";
import { Form, FormGroup, Label, Button } from "@components";

export type FilterOption = $Exact<{ value: string, label: string }>;

type Props = $Exact<{
  ...PropsFromLocalize,
}> &
  FormProps;

export class AbsenceTrendsFilters extends Component<Props> {
  resetForm = () => {
    this.props.reset();
  };

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit} className="d-flex flex-column w-100">
        <div className="d-flex flex-wrap">
          <FormGroup className="mb-0 mx-2 my-2 col-3 p-0">
            <Label for="benchmarkType">{this.props.t("BENCHMARK_TYPE")}</Label>
            <Field
              id="benchmarkType"
              name="benchmarkType"
              className="w-100"
              component={Dropdown}
              options={[]}
            />
          </FormGroup>
          <FormGroup className="mb-0 mx-2 my-2 col-3 p-0">
            <Label for="absenceType">{this.props.t("ABSENCE_TYPE")}</Label>
            <Field
              id="absenceType"
              name="absenceType"
              className="w-100"
              component={Dropdown}
              options={[]}
            />
          </FormGroup>
          <FormGroup className="mb-0 mx-2 my-2 p-0">
            <Label for="fromDate">{this.props.t("FROM")}</Label>
            <Field
              name="fromDate"
              className="w-100"
              component={DatePickerFormWrapper}
              customProps={{ id: "fromDate" }}
            />
          </FormGroup>
          <FormGroup className="mb-0 mx-2 my-2 p-0">
            <Label for="toDate">{this.props.t("TO")}</Label>
            <Field
              name="toDate"
              className="w-100"
              component={DatePickerFormWrapper}
              customProps={{ id: "toDate" }}
            />
          </FormGroup>
        </div>
        <div className="d-flex">
          <FormGroup className="mb-0 mx-2 my-2 col-3 p-0">
            <Label for="periodType">{this.props.t("PERIOD_TYPE")}</Label>
            <Field
              id="periodType"
              name="periodType"
              className="w-100"
              component={Dropdown}
              options={[]}
            />
          </FormGroup>
          <FormGroup className="mb-0 mx-2 my-2 col-3 p-0">
            <Label for="comparators">{this.props.t("COMPARATORS")}</Label>
            <Field
              id="comparators"
              name="comparators"
              className="w-100"
              component={Dropdown}
              options={[]}
            />
          </FormGroup>
        </div>
        <div className="d-flex justify-content-end">
          <Button className="mx-3 font-weight-normal" materialIcon="replay_circle_filled">
            {this.props.t("SUBMIT")}
          </Button>
          {this.props.dirty ? (
            <Button color="secondary" onClick={this.resetForm}>
              {this.props.t("RESET")}
            </Button>
          ) : null}
        </div>
      </Form>
    );
  }
}

export default reduxForm({
  form: "absence-trends-filters",
})(localize()(AbsenceTrendsFilters));
